import { saveAs } from 'file-saver';

/**
 * Downloads an XLSX report from the backend JXLS endpoint.
 *
 * @param {string} reportType - Backend report path (e.g. 'trips', 'stops', 'events', 'summary', 'route')
 * @param {URLSearchParams|object} params - Query parameters (deviceId[], groupId[], from, to, etc.)
 * @param {string} [filename] - Download filename (default: 'report.xlsx')
 */
const downloadReportXlsx = async (reportType, params, filename = 'report.xlsx') => {
  const query = params instanceof URLSearchParams ? params : new URLSearchParams(params);

  const response = await fetch(`/api/reports/${reportType}/xlsx?${query.toString()}`);

  if (!response.ok) {
    throw new Error(await response.text());
  }

  const blob = await response.blob();
  saveAs(blob, filename.endsWith('.xlsx') ? filename : `${filename}.xlsx`);
};

export default downloadReportXlsx;
